export default "__VITE_ASSET__DDhDmNRl__"